import { Component, OnInit, Input } from '@angular/core';
import { DependenciaModel } from 'src/app/models/dependencia.model';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { GlobalService } from 'src/app/shared/global.service';
import { AlertService } from 'src/app/shared/services/alert.service';
import { reporteInformeVisitante } from 'src/app/models/reporteInformeVisitante.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { HttpResponseBase } from '@angular/common/http';
import { UtilService } from 'src/app/shared/services/util.service';

@Component({
  selector: 'app-generar-reportes-medevac', //'app-reporte-medevac',
  templateUrl: './reporte-medevac.component.html',
  styleUrls: ['./../generar-reporte.component.scss']
})
export class ReporteMedevacComponent implements OnInit {
	
	@Input() public dependencia: DependenciaModel[];
    @Input() reporteInformeVisitante: reporteInformeVisitante[];

	public listadoTipoDocumento;
	public listadoMotivoIngresoComo;
    public filtroTipodocumento: string;
    public filtroDocumento: string;
	public filtroNombresApellidos: string;
	public filtroMotivoIngreso: string;
    // public filtroFechaFin: string;
    // public filtroFechaInicio: string;
    public filtroFechaFin: Date;
    public filtroFechaInicio: Date;
    public filtroRol: string;
    public filtroDocumentoRol: string;
    public validar = true;
    public datosArchivo: any;
    public placeholderDate: string;
	
  constructor(
	private global: GlobalService,
	private urlService: UrlService,
	private spinner: NgxSpinnerService,
	private alertService: AlertService,
	private utilService: UtilService
  ) { 
	this.filtroRol = sessionStorage.getItem(ConstantesService.ROL_SESSION);
    this.filtroDocumentoRol = sessionStorage.getItem(ConstantesService.NUM_DOC_SESSSION);
	this.listadoTipoDocumento = [];
	this.listadoMotivoIngresoComo = [];
  }

  ngOnInit() {
	this.placeholderDate = ConstantesService.SELECCION_FECHA;
	this.filtroFechaFin = undefined;
	this.getTipoIdentificacion();
	this.getMotivoIngresoComo();
	
  }
  
  /**
     * Consulta los tipos de documentos
     */
    public getTipoIdentificacion() {
		const serviceProvider = "getTipoIdentificacion";
		const url = this.urlService.getUrl(
		  new UrlControl(serviceProvider, null, null),
		  this.urlService.hostAPI_ACCVIS
		);
		//const sucripcion = 
		this.global.getGenerico(url).subscribe(
		  (data) => {
			this.listadoTipoDocumento = data;
		  },
		  (err) => {
			this.cathException("Error Consultando el Dominio");
		  }
		);
		//this.subscription.push(sucripcion);
	  }
	  
	  /**
     * Consulta los tipos de documentos
     */
    public getMotivoIngresoComo() {
		const serviceProvider = "getMotivoIngresoComo";
		const url = this.urlService.getUrl(
		  new UrlControl(serviceProvider, null, null),
		  this.urlService.hostAPI_ACCVIS
		);
		//const sucripcion = 
		this.global.getGenerico(url).subscribe(
		  (data) => {
			this.listadoMotivoIngresoComo = data;
		  },
		  (err) => {
			this.cathException("Error Consultando el Dominio");
		  }
		);
		//this.subscription.push(sucripcion);
	  }  

    /**
     * Método que recolecta los filtros y realiza el llamado del servicio correspondiente
     * al BACKEND y obtiene el resultado de la consulta deseada
     */
    GenerarReporteInformeVisitante() {
        this.validacion();

        if (!this.validar) {
            this.spinner.show();
            if (this.filtroDocumento && this.filtroDocumento.length > 0 && !/^([A-Z0-9])*$/.test(this.filtroDocumento)) {
                this.cathException('Por favor ingrese nuevamente un “Número de documento”');
                this.cathException('La información ingresada en “Número de documento”'
                    + 'no corresponde con lo solicitado, por favor verifique');
                document.getElementById('numeroDocumento').focus();
                return;
            }

            const filtros = {                
                filtroTipoDocumento: this.filtroTipodocumento,
				filtroDocumento: this.filtroDocumento,                
				filtroNombresApellidos: this.filtroNombresApellidos,
				filtroMotivoIngreso: this.filtroMotivoIngreso,
                filtroFechaInicio: this.filtroFechaInicio,
                filtroFechaFin: this.filtroFechaFin
            };
            const serviceProvider = 'reporteMedevac';
            const url = this.urlService.getUrl(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_ACCVIS);
            this.global.postGenerico(url, filtros).subscribe(
                data => {
                    this.datosArchivo = data;
                    this.spinner.hide();
                    this.alertService.generateAlertSuccess('Su reporte se está descargando', '');
                    this.descargarArchivo();
                }, err => {
                    if (err.status === 500) {
                        this.cathException(err.error.message);
                    } else {
                        this.cathException('El reporte no se ha podido generar');
                    }
                }
            );
        }
    }

    /**
     * Método que convierte el archivo Excel y realiza la descarga del mismo
     */
    descargarArchivo() {
        ConstantesService.descargarDocumento('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            , this.datosArchivo.nombre, this.datosArchivo.archivo);
        this.spinner.hide();
    }

    /**
     * Metodo que valida los campos obligatorios para porder habilitar el boton Generar Reporte
     */
    validacion() {
        if (this.utilService.validarCamposObligatorios(this.filtroFechaInicio)
            && this.utilService.validarCamposObligatorios(this.filtroFechaFin)) {
            this.validar = false;
        } else {
            this.validar = true;
        }
		if (this.filtroTipodocumento === 'undefined') {
            this.filtroTipodocumento = undefined;
        }
        if (this.filtroDocumento === '') {
            this.filtroDocumento = undefined;
        }
		if (this.filtroNombresApellidos === '') {
            this.filtroNombresApellidos = undefined;
        }
		if (this.filtroMotivoIngreso === 'undefined') {
            this.filtroMotivoIngreso = undefined;
        }
    }

    // /**
    //  * Método que valida la fecha Inicial y la anexa a una variable especifica filtroFechaInicio
    //  * @param event resive la fecha seleccionada por el usuario
    //  */
    // public handlerDatePickeRInicio(event) {
    //     this.filtroFechaInicio = this.utilService.convertirFechaConcatenada(event);
    // }

    // /**
    //  * Método que valida la fecha Final y la anexa a una variable especifica filtroFechaFin
    //  * @param event resive la fecha seleccionada por el usuario
    //  */
    // public handlerDatePickeRFin(event) {
    //     this.filtroFechaFin = this.utilService.convertirFechaConcatenada(event);
    // }

    /**
     * Método de control de Excepciones
     * @param error                 mensaje saliente respecto al error ocurrido
     * @param err: HttpResponseBase Tipo de error
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }  

}
